import { render } from "./GridPesquisa.vue?vue&type=template&id=2116f562&ts=true"
import script from "./GridPesquisa.vue?vue&type=script&lang=ts"
export * from "./GridPesquisa.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__